"use client";

/* eslint-disable react/jsx-props-no-spreading */

import React from "react";
import {Skeleton, SkeletonProps, Typography} from "@mui/material";

export interface ParagraphSkeletonProps extends SkeletonProps {
  numLines?: number;
  lastLineWidthPerc?: number;
  testId: string;
  typographyVariant?: "body1" | "body2" | "button" | "caption" | "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "inherit" | "overline" | "subtitle1" | "subtitle2";
}

const ColletteParagraphSkeleton = ({
  numLines = 5,
  lastLineWidthPerc = 80,
  testId,
  typographyVariant = "body1",
  ...rest
}: ParagraphSkeletonProps) => {
  const clampedLastLineWidthPerc = Math.max(1, Math.min(lastLineWidthPerc, 100));
  const clampedNumLines = Math.max(1, Math.min(numLines, 10));

  const longLines = Array.from({ length: clampedNumLines - 1 }, (_, index) => (
    <Skeleton key={index} data-testid={`${testId}_skeleton-line`} {...rest} />
  ));

  return (
    <Typography variant={typographyVariant}>
      {longLines}
      <Skeleton
        data-testid={`${testId}_last-skeleton`}
        width={`${clampedLastLineWidthPerc}%`}
        {...rest}
      />
    </Typography>
  );
};

export default ColletteParagraphSkeleton;
